<template>
    <div style="height: 250" v-if="ready">
        <v-row>
            <v-col cols="12" md="2" class="py-0">
                <v-card class="pl-3 py-1" color="white" height="106">
                    <v-text-field
                        height="35px"
                        background-color="white"
                        hide-details
                        readonly
                        solo
                        flat
                    >
                        <template v-slot:prepend>
                            <v-fade-transition leave-absolute>
                                <v-icon>mdi-led-on</v-icon>
                            </v-fade-transition>
                        </template>
                        <template v-slot:append>
                            <v-fade-transition leave-absolute>
                                <div class="mt-1" v-if="!loading">
                                    <v-btn
                                        small
                                        depressed
                                        v-model="control.value"
                                        :color="control.value ? 'green accent-1' : 'grey lighten-3'" 
                                        @click="dialog1o()"
                                        :disabled="user.level === 'USER'"
                                        >{{control.text}}
                                    </v-btn>
                                </div>
                                <v-progress-circular
                                    v-else
                                    indeterminate
                                    color="accent"
                                ></v-progress-circular>
                            </v-fade-transition>
                        </template>
                    </v-text-field>
                    <p>Control</p>
                    <v-dialog v-model="open1" persistent width="400" class="align-center">
                        <template>
                            <v-card height="160">
                                    <v-toolbar :elevation="0" color="primary" dark>
                                        <v-toolbar-title>Confirm changes</v-toolbar-title>
                                    </v-toolbar>
                                    <v-form ref="form" class="text-center mt-3">
                                        Do you want to {{ msg }} control?
                                    </v-form>
                                    <div align="right" class="align-content-end mx-4 mt-3">
                                        <v-btn color="accent" 
                                            small
                                            class="white--text mx-2"
                                            @click="sendCommand('control')"
                                            >Confirm
                                        </v-btn>
                                        <v-btn color="danger" 
                                            small
                                            text
                                            @click="dialog1c()"
                                            >Cancel
                                        </v-btn>
                                    </div>
                            </v-card>
                        </template>
                    </v-dialog>
                </v-card>
                <v-card class="pl-3 py-1 my-5" color="white" height="106">
                    <v-text-field
                        height="35px"
                        background-color="white"
                        hide-details
                        readonly
                        solo
                        flat
                    >
                        <template v-slot:prepend>
                            <v-fade-transition leave-absolute>
                                <v-icon class="ml-3">mdi-solar-panel-large</v-icon>
                            </v-fade-transition>
                        </template>
                        <template v-slot:append>
                            <v-fade-transition leave-absolute>
                                <div class="mt-1" v-if="!loading">
                                    <v-btn 
                                        small
                                        depressed
                                        v-model="photocell.value"
                                        :color="photocell.value ? 'green accent-1' : 'grey lighten-3'"
                                        @click="dialog2o()"
                                        :disabled="user.level === 'USER'"
                                        >{{photocell.text}}
                                    </v-btn>
                                </div>
                                <v-progress-circular
                                    v-else
                                    indeterminate
                                    color="accent"
                                ></v-progress-circular>
                            </v-fade-transition>
                        </template>
                    </v-text-field>
                    <p>Photocell</p>
                    <v-dialog v-model="open2" persistent width="400" class="align-center">
                        <template>
                            <v-card height="160">
                                    <v-toolbar :elevation="0" color="primary" dark>
                                        <v-toolbar-title>Confirm changes</v-toolbar-title>
                                    </v-toolbar>
                                    <v-form ref="form" class="text-center mt-3">
                                        Do you want to {{msg}} photocell?
                                    </v-form>
                                    <div align="right" class="align-content-end mx-4 mt-3">
                                        <v-btn color="accent" 
                                            small
                                            class="white--text mx-2"
                                            @click="sendCommand('photocell')"
                                            >Confirm
                                        </v-btn>
                                       <v-btn color="danger" 
                                            small 
                                            text
                                            @click="dialog2c()"
                                            >Cancel
                                        </v-btn>
                                    </div>
                            </v-card>
                        </template>
                    </v-dialog>
                </v-card>
            </v-col>
            <v-col cols="12" md="4" class="py-0">
                <v-card height="232">
                    <v-list-item dense>
                        <v-list-item-avatar>
                            <v-icon>mdi-clock</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="ml-n1">
                            Schedule Setup
                        </v-list-item-content> 
                        <v-list-item-icon class="d-flex">
                            <div class="mt-1 mr-n1" v-if="!loading">
                                <v-btn 
                                    small
                                    depressed
                                    color="grey lighten-3"
                                    @click="dialog5o()"
                                    v-model="suntime"
                                    :disabled="user.level === 'USER'"
                                    >
                                   <v-icon v-if="suntime" class="mr-2">mdi-white-balance-sunny</v-icon>
                                   <v-icon v-else class="mr-2">mdi-account-clock</v-icon>
                                   {{textSuntime}}
                                </v-btn>
                            </div>
                            <v-progress-circular
                                v-else
                                indeterminate
                                color="accent"
                            ></v-progress-circular>
                            <v-dialog v-model="open5" persistent width="400" class="align-center">
                                <template>
                                    <v-card height="160">
                                            <v-toolbar :elevation="0" color="primary" dark>
                                                <v-toolbar-title>Confirm changes</v-toolbar-title>
                                            </v-toolbar>
                                            <v-form ref="form" class="text-center mt-3">
                                                Do you want to {{msg}} solar schedule?
                                            </v-form>
                                            <div align="right" class="align-content-end mx-4 mt-3">
                                                <v-btn color="accent" 
                                                    small
                                                    class="white--text mx-2"
                                                    @click="sendScheduleSun('suntime', suntime)"
                                                    >Confirm
                                                </v-btn>
                                                <v-btn color="danger" 
                                                    small 
                                                    text
                                                    @click="dialog5c()"
                                                    >Cancel
                                                </v-btn>
                                            </div>
                                    </v-card>
                                </template>
                            </v-dialog>
                        </v-list-item-icon>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-card-text class="text-center d-flex py-9">
                        <div style="width: 50%" class="my-auto">
                            <p v-if="suntime"
                                class="my-0 subtitle-1 text-h6 font-weight-bold primary--text">
                                {{sunset_suntime_hours}}:{{sunset_suntime_minutes}}
                            </p>
                            <p v-else
                                @click="openMenuSchedule('on')"
                                class="my-0 subtitle-1 text-h6 font-weight-bold primary--text">
                                {{ this.on_schedule.hours }}:{{ this.on_schedule.minutes }}
                            </p>
                            <p class="text-caption my-0">ON</p>
                            <div class="mt-1" v-if="!loading">
                                <v-btn
                                    v-if="!suntime"
                                    small
                                    depressed
                                    v-model="on_schedule.status"
                                    :color="on_schedule.status ? 'green accent-1' : 'grey lighten-3'"
                                    :disabled="user.level === 'USER'" 
                                    @click="dialog3o()">
                                    {{on_schedule.text}}
                                </v-btn>
                            </div>
                            <v-progress-circular
                                v-else
                                indeterminate
                                color="accent"
                            ></v-progress-circular>
                            <v-dialog v-model="open3" persistent width="420" class="align-center">
                                <template>
                                    <v-card height="160">
                                            <v-toolbar :elevation="0" color="primary" dark>
                                                <v-toolbar-title>Confirm changes</v-toolbar-title>
                                            </v-toolbar>
                                            <v-form ref="form" class="text-center mt-3">
                                                Do you want to {{msg}} ON Schedule?
                                            </v-form>
                                            <div align="right" class="align-content-end mx-4 mt-3">
                                                <v-btn color="accent" 
                                                    small
                                                    class="white--text mx-2"
                                                    @click="confirmChangeON()"
                                                    >Confirm
                                                </v-btn>
                                                <v-btn color="danger" 
                                                    small
                                                    text
                                                    @click="dialog3c()"
                                                    >Cancel
                                                </v-btn>
                                            </div>
                                    </v-card>
                                </template>
                            </v-dialog>
                        </div>
                        <v-divider vertical></v-divider>
                        <div style="width: 50%" class="my-auto">
                            <p v-if="suntime" 
                                class="my-0 subtitle-1 text-h6 font-weight-bold primary--text">
                                {{sunrise_suntime_hours}}:{{sunrise_suntime_minutes}}
                            </p>
                            <p v-else
                                @click="openMenuSchedule('off')"
                                class="my-0 subtitle-1 text-h6 font-weight-bold primary--text">
                                {{ this.off_schedule.hours }}:{{ this.off_schedule.minutes }}
                            </p>
                            <p class="text-caption my-0">OFF</p>
                            <div class="mt-1" v-if="!loading">
                                <v-btn
                                    v-if="!suntime"
                                    small
                                    depressed
                                    v-model="off_schedule.status"
                                    :color="off_schedule.status ? 'green accent-1' : 'grey lighten-3'"
                                    :disabled="user.level === 'USER'" 
                                    @click="dialog4o()"
                                    >{{off_schedule.text}}
                                </v-btn>
                            </div>
                            <v-progress-circular
                                v-else
                                indeterminate
                                color="accent"
                            ></v-progress-circular>
                            <v-dialog v-model="open4" persistent width="420" class="align-center">
                                <template>
                                    <v-card height="160">
                                            <v-toolbar :elevation="0" color="primary" dark>
                                                <v-toolbar-title>Confirm changes</v-toolbar-title>
                                            </v-toolbar>
                                            <v-form ref="form" class="text-center mt-3">
                                                Do you want to {{msg}} OFF Schedule?
                                            </v-form>
                                            <div align="right" class="align-content-end mx-4 mt-3">
                                                <v-btn color="accent" 
                                                    small
                                                    class="white--text mx-2"
                                                    @click="confirmChangeOFF()"
                                                    >Confirm
                                                </v-btn>
                                                <v-btn color="danger" 
                                                    small
                                                    text
                                                    @click="dialog4c()"
                                                    >Cancel
                                                </v-btn>
                                            </div>
                                    </v-card>
                                </template>
                            </v-dialog>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="py-0" :class="[$vuetify.breakpoint.smAndDown ? 'mt-3' : '']">
                <v-card height="232">
                    <v-list-item dense>
                        <v-list-item-avatar>
                            <v-icon>mdi-clock-outline</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="ml-n1">
                            Current Schedules
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-card-text class="text-center d-flex">
                        <div align="center" style="width: 100%; position: relative; top: -10px">
                            <v-row class="font-weight-black">
                                <v-col cols="3" class="ml-n1">Device</v-col>
                                <v-col cols="3" class="ml-n2">ON</v-col>
                                <v-col cols="3" class="ml-0">OFF</v-col>
                                <v-col cols="3">Mode</v-col>
                            </v-row>
                            <div class="mt-n1">
                                <v-card flat height="120" class="scroll">
                                    <v-row                                       
                                        v-for="m in group.meters" 
                                        :key="m.circuit"
                                        class="mt-n5 mx-n4 mb-n12"
                                    >
                                        <v-col cols="3" style="width: 100%; position: relative; top: -10px">
                                            <v-card-text
                                                >{{m.circuit}}
                                            </v-card-text>
                                        </v-col>
                                        <v-col cols="3" style="width: 100%; position: relative; top: -10px">
                                            <v-card-text v-if="m.suntime">{{sunset_suntime_hours}}:{{sunset_suntime_minutes}}</v-card-text>
                                            <v-card-text v-else>{{m.schedule.ON}}</v-card-text> 
                                        </v-col>
                                        <v-col cols="3" style="width: 100%; position: relative; top: -10px">
                                            <v-card-text v-if="m.suntime">{{sunrise_suntime_hours}}:{{sunrise_suntime_minutes}}</v-card-text>
                                            <v-card-text v-else>{{m.schedule.OFF}}</v-card-text>
                                        </v-col>
                                        <v-col cols="3" style="width: 100%; position: relative; top: -10px">
                                            <v-card-text>
                                                <v-icon v-if="m.suntime" class="mt-n1">mdi-white-balance-sunny</v-icon>
                                                <v-icon v-else class="mt-n1">mdi-account-clock</v-icon>
                                            </v-card-text>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </div>
                        </div>
                        
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="mt-auto">
                    <v-row>
                        <v-col class="mt-n3">
                            <v-list-item dense>
                            <v-list-item-avatar>
                                <v-icon>mdi-lightning-bolt-circle</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content class="ml-n1">
                                Select devices
                            </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                        <v-row>
                            <v-col cols="12" md="6" align="stretch">
                                <v-row :class="[$vuetify.breakpoint.smAndDown ? 'pos4' : 'pos3']">
                                    <v-col cols="12" class="mt-n3">
                                        <v-chip-group
                                            active-class="primary--text"
                                            column
                                            multiple
                                            v-model="unselectedMeters"
                                            @change="log()"
                                        >
                                            <v-chip
                                            v-for="m in group.meters"
                                            :key="m.name"
                                            filter
                                            >
                                            {{ m.circuit }}
                                            </v-chip>
                                        </v-chip-group>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="6" :class="[$vuetify.breakpoint.smAndDown ? 'pos1' : 'pos2']">
                                <v-row align="stretch">
                                    <v-col cols="12" class="d-flex justify-center align-center mt-n5">
                                        <v-btn v-model="selected" text @click="selectAll(selected)" :color="selected ? 'danger' : 'accent'">{{ selected ? 'Unselect All Devices' : 'Select All Devices'}}</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row align="stretch">
                                    <v-col cols="12" class="d-flex justify-center align-center mt-n5">
                                        <v-btn text color="blue" :disabled="unselectedMeters.length === 0" class="white--text" @click="opApply = true">Apply Changes</v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="schedule.menu" max-width="400px">
            <v-card>
                <v-card-text class="py-3">
                    <p class="subtitle-1 font-weight-bold primary--text"
                        >{{ schedule.type === 'on' ? 'ON' : 'OFF'}} Schedule
                    </p>
                    <p class="mb-1"
                        >Hour
                    </p>
                    <v-select
                        v-model="schedule.hours"
                        :items="Array.from(Array(24).keys())"
                        solo
                        outlined
                        flat
                    ></v-select>
                    <p class="mb-1">Minutes</p>
                    <v-select
                        v-model="schedule.minutes"
                        :items="Array.from(Array(60).keys())"
                        solo
                        outlined
                        flat
                    ></v-select>
                    <v-btn 
                        block color="accent" 
                        :disabled="!Number.isInteger(schedule.hours) || !Number.isInteger(schedule.minutes)" 
                        @click="dialogControlOpen()"
                        >Save
                    </v-btn>
                    <v-btn 
                        @click="cancelSchedule" 
                        block 
                        text 
                        color="danger"
                        class="mt-2"
                        >Cancel
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="openUp" persistent width="400" class="align-center">
            <template>
                <v-card height="160">
                        <v-toolbar :elevation="0" color="primary" dark>
                            <v-toolbar-title>Confirm changes</v-toolbar-title>
                        </v-toolbar>
                        <v-form ref="form" class="text-center mt-3">
                            Do you want to proceed with this change?
                        </v-form>
                        <div align="right" class="align-content-end mx-4 mt-3">
                            <v-btn color="accent" 
                                small
                                class="white--text mx-2"
                                @click="sendSchedule(schedule.type)" 
                                >Confirm
                            </v-btn>
                            <v-btn color="danger" 
                                small 
                                text
                                @click="dialogControlClose()"
                                >Cancel
                            </v-btn>
                        </div>
                </v-card>
            </template>
        </v-dialog>
        <v-snackbar v-model="error.active" :timeout="3000">
            {{ error.message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="error.active = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <formApply :open="opApply" :metersToChange="unselectedMeters" :originalMeters="group.meters" :group="group" :on="on_schedule" :off="off_schedule" @save="saveChanges(unselectedMeters)" @close="opApply = false"/>
    </div>
</template>

<script>
import { mapState, mapActions }  from 'vuex'
import formApply from '../formApplyGroupChanges.vue'
export default {
    name: 'control',
    props: ['group'],
    computed: {
        ...mapState({
            user: state => state.user.profile,
            location: state => state.user.location,
            sunrise_suntime_hours : state => state.user.sunrise_suntime_hours,
            sunrise_suntime_minutes: state => state.user.sunrise_suntime_minutes,
            sunset_suntime_hours: state => state.user.sunset_suntime_hours,
            sunset_suntime_minutes: state => state.user.sunset_suntime_minutes,
            sky_ofs: state => state.user.sky_ofs,
            schedules: state => state.schedules.schedules,
        }),
    },
    components: { formApply },
    data() {
        return {
            control: {
                text: '',
                value: false
            },
            photocell: {
                text: '',
                value: false
            },
            suntime: false,
            schedule: {
                menu: false,
                minutes: null,
                hours: null,
                type: ''
            },
            on_schedule: {
                minutes: '',
                hours: '',
                status: false,
                text: '',
                msg: ''
            },
            off_schedule: {
                minutes: '',
                hours: '',
                status: false,
                text: '',
                msg: ''
            },
            loading: false,
            error: {
                active: false,
                message: ''
            },
            openUp: false,
            open1: false,
            open2: false,
            open3: false,
            open4: false,
            open5: false,
            msg: '',
            textSuntime: '',
            statusBtn: false,
            current_on_schedule: '',
            current_off_schedule: '',
            unselectedMeters: [],
            selectedMeters: [],
            selected: false,
            opApply: false,
            ready: false
        }
    },
    methods:{
        ...mapActions({ 
            controlMeter: 'meters/controlMeter',
            scheduleMeter: 'meters/scheduleMeter',
            activeSuntime: 'meters/activeSuntime',
            updateMeterFromApi: 'meters/updateMeterFromApi',
            editGroupDataControl: 'meters/editGroupDataControl',
            editGroupSchedules: 'meters/editGroupSchedules'
        }),
        async init(){
            this.ready = false
            for (let index = 0; index < this.group.meters.length; index++) {
                const element = this.group.meters[index];
                await this.updateMeterFromApi(element.name)
                await this.checkMetersSchedule(element)
            }
            this.setGroupSchedule(this.group.timeON, this.group.timeOFF)
            this.suntime = this.group.suntime
            this.control.value = this.group.control
            this.control.text = this.control.value ? 'On' : 'Off'
            this.photocell.value = this.group.photocell
            this.photocell.text = this.photocell.value ? 'On' : 'Off'
            this.textSuntime = this.suntime ? 'Solar' : 'Manual'
            this.on_schedule.status = (!this.suntime) ? true : false
            this.off_schedule.status = (!this.suntime) ? true : false
            this.on_schedule.text = this.on_schedule.status ? 'On' : 'Off'
            this.off_schedule.text = this.off_schedule.status ? 'On' : 'Off'
            this.ready = true
        },
        setGroupSchedule(timeON, timeOFF){
            const on_time = timeON ? timeON.split(':').map( t => parseInt(t)): null
            const off_time = timeOFF ? timeOFF.split(':').map( t => parseInt(t)): null
            this.on_schedule.hours = ("0" + on_time[0]).slice(-2)
            let on_h = Number(this.on_schedule.hours)
            on_h += this.sky_ofs
            if (on_h < 0) {
                on_h += 24 
            }
            on_h = ("0" + (on_h)).slice(-2)
            this.on_schedule.hours = on_h
            this.on_schedule.minutes = ("0" + on_time[1]).slice(-2)
            this.off_schedule.hours = ("0" + off_time[0]).slice(-2)
            let off_h = Number(this.off_schedule.hours)
            off_h += this.sky_ofs
            if (off_h < 0) {
                off_h += 24 
            }
            off_h = ("0" + (off_h)).slice(-2)
            this.off_schedule.hours = off_h
            this.off_schedule.minutes = ("0" + off_time[1]).slice(-2)
        },
        checkMetersSchedule(m){
            let on_schedule = { hours: '', minutes: '' }
            let off_schedule = { hours: '', minutes: '' }
            if(m.schedule){
                const on_time = m.schedule.ON ? m.schedule.ON.split(':').map( t => parseInt(t)): null
                const off_time = m.schedule.OFF ? m.schedule.OFF.split(':').map( t => parseInt(t)): null
                if(on_time){
                    on_schedule.hours = ("0" + on_time[0]).slice(-2)
                    on_schedule.minutes = ("0" + on_time[1]).slice(-2)
                    let on_h = Number(on_schedule.hours)
                    on_h += this.sky_ofs
                    if (on_h < 0) {
                        on_h += 24 
                    }
                    on_h = ("0" + (on_h)).slice(-2)
                    on_schedule.hours = on_h
                    let hr = on_schedule.hours + ":" + on_schedule.minutes
                    m.schedule.ON = hr
                }
                if(off_time){
                    off_schedule.hours = ("0" + off_time[0]).slice(-2)
                    off_schedule.minutes = ("0" + off_time[1]).slice(-2)
                    let off_h = Number(off_schedule.hours)
                    off_h += this.sky_ofs
                    if (off_h < 0) {
                        off_h += 24 
                    }
                    off_h = ("0" + (off_h)).slice(-2)
                    off_schedule.hours = off_h
                    let hr = off_schedule.hours + ":" + off_schedule.minutes
                    m.schedule.OFF = hr
                }
            }
        },
        async sendCommand(type){
            try {
                this[type].value = !this[type].value
                this.loading = true
                this[type].text = this[type].value ? 'Activating...' : 'Deactivating...'
                let active = this[type].value
                let n = this.group.name
                let g = this.group
                await this.editGroupDataControl({n, type, active, g})
                this.loading = false
                this[type].text = this[type].value ? 'On' : 'Off'
            } catch (error) {
                this[type].value = !this.control.value
                this[type].text = this.control.value ? 'ON Schedule' : 'OFF Schedule'
                this.error.message = 'Error on instruccion'
                this.error.active = true
                this.loading = false
            }
            this.open1=false
            this.open2=false       
        },
        async sendSchedule(type){
            try {
                this.loading = true
                let n = this.group.name
                let g = this.group
                this[type + '_schedule'].hours = ("0" + this.schedule.hours).slice(-2)
                this[type + '_schedule'].minutes = ("0" + this.schedule.minutes).slice(-2)
                let hh = Number(this[type + '_schedule'].hours)
                hh -= this.sky_ofs
                if (hh > 24) {
                    hh -= 24 
                }
                hh = ("0" + (hh)).slice(-2)
                let mm = this[type + '_schedule'].minutes
                let diff = this.sky_ofs
                this.editGroupSchedules({n, type, hh, mm, g, diff})
                this.closeMenuSchedule()
                this.dialogControlClose()
                this.loading = false
            } catch (error) {
                console.log(error)
                this.error.message = 'Error on instruction'
                this.error.active = true
                this.loading = false
            }
        },
        async sendScheduleSun(type, sunStatus){
            try {
                this.loading = true
                this.textSuntime = sunStatus ? 'Manual' : 'Solar'
                this.suntime = !sunStatus
                this.group.suntime = this.suntime
                let active = this.group.suntime
                let n = this.group.name
                let g = this.group
                await this.editGroupDataControl({n, type, active, g})
                this.loading = false
            } catch (error) {
                this.error.message = 'Error on instruction'
                this.error.active = true
                this.loading = false
            }
            this.dialog5c()
        },
        convertSchedule(on_hours, off_hours){
            if(on_hours){ 
                let on_schedule = Number(on_hours)
                on_schedule += this.sky_ofs
                if (on_schedule < 0) {
                    on_schedule += 24 
                }
                on_schedule = ("0" + (on_schedule)).slice(-2)
                this.on_schedule.hours = on_schedule
            } else {
                this.on_schedule.msg = 'Click to configure ON schedule'
            }
            if(off_hours){
                let off_schedule = Number(off_hours)
                off_schedule += this.sky_ofs
                if (off_schedule < 0) {
                    off_schedule += 24 
                }
                off_schedule = ("0" + (off_schedule)).slice(-2)
                this.off_schedule.hours = off_schedule
            } else {
                this.off_schedule.msg = 'Click to configure OFF schedule'
            }
        },
        changeControlSchedule(type){
            this.dialog3o()
        },
        changeControlSchedule1(type){
            this.dialog4o()
        },
        async confirmChangeON(){
            this.on_schedule.status = !this.on_schedule.status
            this.schedule.hours = this.on_schedule.hours
            this.current_on_schedule = this.schedule.hours
            this.schedule.minutes = this.on_schedule.minutes
            if(this.on_schedule.status) {
                await this.scheduleMeter({
                    meter: this.meter.name,
                    data: {
                        hours: this.schedule.hours,
                        minutes: this.schedule.minutes,
                        control: "ON",
                        timezone: this.sky_ofs
                    }  
                })
            } else {
                await this.scheduleMeter({
                    meter: this.meter.name,
                    data: {
                        control: "ON",
                        inactive: true
                    }
                })
            }
            this.dialog3c()
            this.schedule.type = ''
            this.on_schedule.text = this.on_schedule.status ? 'On' : 'Off'
        },
        async confirmChangeOFF(){
            this.off_schedule.status = !this.off_schedule.status
            this.schedule.hours = this.off_schedule.hours
            this.current_off_schedule = this.schedule.hours
            this.schedule.minutes = this.off_schedule.minutes
            if(this.off_schedule.status) {
                await this.scheduleMeter({
                    meter: this.meter.name,
                    data: {
                        hours: this.off_schedule.hours,
                        minutes: this.off_schedule.minutes,
                        control: "OFF",
                        timezone: this.sky_ofs
                    }  
                })
            } else {
                await this.scheduleMeter({
                    meter: this.meter.name,
                    data: {
                        control: "OFF",
                        inactive: true
                    }
                })
            }
            this.dialog4c()
            this.schedule.type = ''
            this.off_schedule.text = this.off_schedule.status ? 'On' : 'Off'
        },
        dialogControlOpen(){
            this.openUp = true
        },
        dialogControlClose(){
            this.openUp = false
        },
        dialog1o(){
            this.msg = this.control.value ? 'deactivate' : 'activate'
            this.open1 = true
        },
        dialog1c(){
            this.open1 = false
        },
        dialog2o(){
            this.msg = this.photocell.value ? 'deactivate' : 'activate'
            this.open2 = true
        },
        dialog2c(){
            this.open2 = false
        },
        dialog3o(){
            this.msg = this.on_schedule.status ? 'deactivate' : 'activate'
            this.open3 = true
        },
        dialog3c(){
            this.open3 = false
        },
        dialog4o(){
            this.msg = this.off_schedule.status ? 'deactivate' : 'activate'
            this.open4 = true
        },
        dialog4c(){
            this.open4 = false
        },
        dialog5o(){
            this.msg = this.suntime ? 'deactivate' : 'activate'
            this.open5 = true
        },
        dialog5c(){
            this.open5 = false
        },
        openMenuSchedule(type){
            if (this.suntime) return
            this.schedule.type = type
            this.schedule.hours = parseInt(this[type + '_schedule'].hours)
            this.schedule.minutes = parseInt(this[type + '_schedule'].minutes)
            this.schedule.menu = true
        },
        cancelSchedule(){
            this.closeMenuSchedule()
        },
        closeMenuSchedule(){
            this.schedule.type = ''
            this.schedule.hours = null
            this.schedule.minutes = null
            this.schedule.menu = false
        },
        log(){
            this.selected = false
        },
        setSelect(){
            this.meter.forEach(element => {
                let obj = {
                    selected: false,
                    meter: element
                }
                this.unselectedMeters.push(obj)
            });
        },
        selectAll(status){
            this.selected = !status
            if (this.selected) {
                if (this.unselectedMeters.length >= 1) {
                    this.unselectedMeters = []
                }
                for (let index = 0; index < this.group.meters.length; index++) {
                    this.unselectedMeters.push(index)
                }
            } else {
                this.unselectedMeters = []
            }
        },
        saveChanges(meters){
            let arr = []
            for (let index = 0; index < meters.length; index++) {
                const idxAux = meters[index];
                arr.push(this.group.meters[idxAux])
            }
            this.selectedMeters = arr
            this.unselectedMeters = []
            this.selected = false
        }
    },
    async created() {
        this.init()
    },
}
</script>

<style scoped>
.pos1{
    position: relative;
    left: 0px;
}
.pos2{
    position: relative;
    left: -50px;
}
.pos3{
    position: relative;
    left: 50px;
}
.pos4{
    position: relative;
    left: 0px;
}
.w1{
    width: auto
}
.w2{
    width: 700px;
}
.scroll {
   overflow-y: auto;
   overflow-x: hidden;
}
</style>